import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { getTier } from '../utils/score';
interface MastheadProps {
  seenCount: number;
  total: number;
}
export function Masthead({
  seenCount,
  total
}: MastheadProps) {
  const tier = getTier(seenCount);
  return <header className="border-b-2 border-ink pb-8 pt-10 md:pt-14" data-id="element-33" data-mp="2mqv8jch3cyjg">
      <div className="flex flex-col gap-8 md:flex-row md:items-end md:justify-between" data-id="element-34" data-mp="2mp0mfuu330ds">
        <div className="max-w-2xl" data-id="element-35" data-mp="27s1cw1fo8xgo">
          <p className="font-sans text-sm text-muted" data-id="element-36" data-mp="2csny7chb5eqf">
            A list by{' '}
            <a href="https://www.nytimes.com/bestTV" target="_blank" rel="noreferrer" className="font-serif text-base font-bold text-ink underline decoration-rule underline-offset-4 hover:decoration-ink" data-id="element-37" data-mp="2cqb5q5dxblz4">
              The New York Times
            </a>
          </p>
          <h1 className="mt-2 font-serif text-4xl leading-[1.08] text-ink md:text-6xl" data-id="element-38" data-mp="215x79fljuvi">
            The 100 Best TV Shows of the 21<sup className="text-[0.45em]" data-id="element-39" data-mp="2iedkmi6sxhl7">st</sup> Century
          </h1>
          <p className="mt-4 max-w-lg font-sans text-base text-muted" data-id="element-40" data-mp="2eed3gpsbisag">
            How many have you actually watched? Mark each show, see where you rank, then share your
            grid with friends.
          </p>
        </div>

        <div className="shrink-0 md:text-right" aria-live="polite" data-id="element-41" data-mp="2n7ge6qbkwr1e">
          <div className="flex items-baseline gap-2 md:justify-end" data-id="element-42" data-mp="1zg160gx4ffi8">
            <span className="relative inline-block overflow-hidden font-serif text-7xl leading-none text-ink md:text-8xl" data-id="element-43" data-mp="1zidxbkorr27y">
              <AnimatePresence mode="popLayout" initial={false} data-id="element-44" data-mp="29egwqis8kmr7">
                <motion.span key={seenCount} className="inline-block tabular-nums" initial={{
                y: '40%',
                opacity: 0
              }} animate={{
                y: 0,
                opacity: 1
              }} exit={{
                y: '-40%',
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-45" data-mp="29cnrn7x9ualb">
                  {seenCount}
                </motion.span>
              </AnimatePresence>
            </span>
            <span className="font-serif text-2xl text-muted" data-id="element-46" data-mp="3rviwmmxrvnty">/ {total}</span>
          </div>
          <p className="mt-2 font-sans text-sm font-bold text-ink" data-id="element-47" data-mp="s3zcvrak5yz">{tier.title}</p>
          <p className="font-sans text-sm text-muted" data-id="element-48" data-mp="5q5g3a18vt7a">{tier.blurb}</p>
        </div>
      </div>
    </header>;
}